// extracted by mini-css-extract-plugin
export default {"form":"EmailForm-module--form--bc23d","caption":"EmailForm-module--caption--b1bae","spinner":"EmailForm-module--spinner--1c1e5"};